import { i18n } from 'boot/i18n';

export default {
  regionLabel: () => (region) => i18n.t(`regions.${region}`),

  currentRegionLabel: (state) => i18n.t(`regions.${state.region}`),

  regionOptions: () => {
    const regions = [{
      label: i18n.t('regions.eu'),
      value: 'eu',
    }, {
      label: i18n.t('regions.ca'),
      value: 'ca',
    }];

    if (process.env.ENV_TYPE === 'production') {
      regions.push({
        label: i18n.t('regions.us'),
        value: 'us',
      }, {
        label: i18n.t('regions.au'),
        value: 'au',
      });
    }

    return regions;
  },
};
